// src/pages/SwitchSuppliersPage.jsx

import React, { useState } from "react";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";
import PageHeader from "../components/ui/PageHeader";
import SwitchSupplierList from "../components/switchSuppliers/SwitchSupplierList";
import SwitchSupplierForm from "../components/switchSuppliers/SwitchSupplierForm";

const SwitchSuppliersPage = () => {
  const theme = useTheme();
  const [showForm, setShowForm] = useState(false);
  const [editingSupplier, setEditingSupplier] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleEdit = (supplier) => {
    setEditingSupplier(supplier);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingSupplier(null);
    setRefreshKey((k) => k + 1);
  };

  const handleClose = () => {
    setShowForm(false);
    setEditingSupplier(null);
  };

  return (
    <Box>
      <PageHeader
        title="Comercializadoras"
        action={
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditingSupplier(null);
              setShowForm(true);
            }}
            sx={{
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: 'none',
              '&:hover': {
                boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
                filter: 'brightness(1.05)',
              },
            }}
          >
            Nueva Comercializadora
          </Button>
        }
      />

      <SwitchSupplierList 
        key={refreshKey} 
        onEdit={handleEdit} 
      />

      <Dialog
        open={showForm}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <SwitchSupplierForm
            supplier={editingSupplier}
            onSave={handleSave}
            onCancel={handleClose}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default SwitchSuppliersPage;